import { Variants } from '@ds/components/Picker'

import { tw } from '@core/tailwind'

import GradesModal from './components/GradesModal'
import RecommendedModal from './components/RecommendedModal'

export const PICKERS_MODALS = {
  recommended_variants: RecommendedModal,
  grades: GradesModal,
}

// When a picker from this group is selected, its `emphasis`
// value overrides the colors of all selected pickers
export const PICKER_GROUP_WITH_THEME = 'recommended_variants'

// When a picker from this group is selected,
// it loads on battery selection
export const PICKER_GROUP_WITH_LOAD = 'grades'

// Tailwind color matching the variant theme. Used to customize the price color in various places
export const PICKER_VARIANT_TO_COLOR = {
  [Variants.Default]: tw`text-primary`,
  [Variants.Accent]: tw`text-accent`,
  [Variants.Info]: tw`text-info`,
}
